import Vue from 'vue';
import validate from 'mixins/validate';
import phone from 'mixins/phone-validation';
import 'lib/vue-phone-input.js';
const postalCodes = require('postal-codes-js');

export default {
  components: {
    'select-input': () => import('../select-input/select-input.vue'),
    checkbox: () => import('../checkbox/checkbox.vue'),
  },
  props: [
    'firstName',
    'lastName',
    'company',
    'address1',
    'address2',
    'city',
    'province',
    'zip',
    'country',
    'phone',
    'isDefault',
    'id',
    'toggleNewAddressForm',
  ],
  data() {
    return {
      activeCountry: this.getCountryFromCode(this.country),
      tooltipActive: false,
    };
  },
  mixins: [validate, phone],
  computed: {
    optionName() {
      return { name: 'address[phone]' };
    },
    showProvinceSelect() {
      return (
        this.activeCountry &&
        Countries[this.activeCountry] &&
        (Countries[this.activeCountry].provinces || []).length
      );
    },
    formAction() {
      if (this.id) {
        return `/account/addresses/${this.id}`;
      } else {
        return '/account/addresses';
      }
    },
    isUpdatingExistingAddress() {
      return !!this.id;
    },
    provincesArray() {
      if (!this.showProvinceSelect) {
        return [];
      }
      const opts = Countries[this.activeCountry].province_codes;
      return Object.keys(opts).map((label) => ({
        label,
        value: opts[label],
      }));
    },
  },
  methods: {
    checkIfPhoneEmpty() {
      const phoneRef = this.$refs['phone'];
      const phoneInput = phoneRef.querySelector('.vti__input');
      let isFilled = true;

      if (!phoneInput.value) {
        phoneRef.classList.add('has-errors');

        isFilled = false;
      }

      return isFilled;
    },
    validateAddressForm(event) {
      const checkPhone = this.phoneValidation();
      const countrySelectDropdown = this.$refs['countrySelect'];
      const provinceSelect = this.$refs['provinceSelect'];
      const phoneIsFilled = this.checkIfPhoneEmpty();

      let isValid = this.$children
        .filter((c) => typeof c.validateInput !== 'undefined')
        .map((c) => {
          const validInput = c.validateInput();
          this.highlightErrors(c, validInput);

          return c.validateInput();
        })
        .every((res) => res);

      // check if country region select is not empty
      if (countrySelectDropdown?.inputValue === 'placeholder') {
        countrySelectDropdown.isValid = false;
        isValid = false;
        window.dataLayer.push({
          event: 'error_captured',
          error_message: 'country is required',
        });
      }

      if (provinceSelect) {
        if (provinceSelect.inputValue === 'placeholder') {
          provinceSelect.isValid = false;
          isValid = false;
        }
      }

      // check if user added a phone and if its valid
      if (!checkPhone) {
        isValid = false;
        this.phoneValidation(true);

        window.dataLayer.push({
          event: 'error_captured',
          error_message: 'phone is not valid',
        });
      }

      if (!phoneIsFilled) {
        isValid = false;

        window.dataLayer.push({
          event: 'error_captured',
          error_message: 'phone cannot be empty',
        });
      }

      if (!this.validateZipCode()) {
        isValid = false;
      }

      if (!isValid) {
        event.preventDefault();
      }
    },
    getInitialValue(name) {
      const match = name.match(/\[(.*)\]/);
      if (!match[1]) {
        return '';
      }
      const str = match[1];

      switch (str) {
        case 'first_name':
          return this.firstName || '';
        case 'last_name':
          return this.lastName || '';
        case 'zip':
          setTimeout(() => {
            const zipInput = this.$refs['zip'];
            if (zipInput.inputValue.length <= 0) {
              zipInput.dirty = false;
              zipInput.isValid = true;
            }
          });

          return this.zip || '';
        case 'default':
          return !!this.isDefault;
        default:
          return this[str] || '';
      }
    },
    getCountryFromCode(value) {
      return Object.keys(Countries).find((k) => Countries[k].code === value);
    },
    validateZipCode() {
      const countrySelectDropdown = this.$refs['countrySelect'];
      const zipInput = this.$refs['zip'];
      const isValidZipCode = postalCodes.validate(
        countrySelectDropdown.inputValue,
        zipInput.inputValue,
      );
      let validZip = true;

      if (isValidZipCode.length !== undefined) {
        zipInput.dirty = true;
        zipInput.isValid = false;

        validZip = false;
      } else {
        zipInput.dirty = false;
        zipInput.isValid = true;
      }

      return validZip;
    },
    onInputChange({ name, value }) {
      const match = /\D\[(\D+)\]/.exec(name);
      const countrySelectDropdown = this.$refs['countrySelect'];

      if (!match || !match[1]) {
        return false;
      }
      if (match[1] === 'country' && value) {
        const countrySelectDropdown = this.$refs['countrySelect'];
        this.activeCountry = this.getCountryFromCode(value);
        const country = Countries[this.activeCountry];
        countrySelectDropdown.isValid = true;

        if (value !== 'placeholder') {
          countrySelectDropdown.isActive = true;
        }

        this.validateZipCode();
      }

      if (match[1] === 'zip') {
        this.validateZipCode();
      }

      if (match[1] === 'province' && value) {
        const provinceSelectDropdown = this.$refs['provinceSelect'];
        provinceSelectDropdown.isValid = true;

        if (value !== 'placeholder') {
          provinceSelectDropdown.isActive = true;
        }
      }
    },
    generateCountryArray() {
      return Object.keys(Countries).map((label) => ({
        label,
        value: Countries[label].code,
      }));
    },
    showTooltipContent() {
      this.tooltipActive = true;
    },
    hideTooltipContent() {
      this.tooltipActive = false;
    },
    checkFocus(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.hideTooltipContent();
      }
    },
  },
};
